import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRouteSupportPatient = ({ children }) => {
  const isAuthenticated = localStorage.getItem("supportPatientToken");
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRouteSupportPatient;
